import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const easeLuxury = [0.22, 1, 0.36, 1];

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.2 },
  },
};

const item = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: easeLuxury } },
};

export default function Hero({ onCta, onSecondaryCta }) {
  const { scrollYProgress } = useScroll();
  const bgY = useTransform(scrollYProgress, [0, 1], ['0%', '30%']);

  return (
    <section className="relative min-h-screen flex items-end overflow-hidden bg-bg-primary">
      {/* Cinematic background */}
      <motion.div style={{ y: bgY }} className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a1a1a] via-[#0f0f0f] to-black" />
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: 'radial-gradient(circle at 25% 30%, rgba(225,29,42,0.25), transparent 45%), radial-gradient(circle at 80% 70%, rgba(201,169,97,0.18), transparent 50%)'
        }} />
      </motion.div>
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-black via-black/50 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pb-20 sm:pb-28 pt-28 sm:pt-36 lg:pt-56 w-full">
        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          className="max-w-4xl space-y-8"
        >
          <motion.p
            variants={item}
            className="text-accent-gold font-semibold tracking-[0.3em] uppercase text-sm"
          >
            Tekkeköy • Samsun • 2001'den Beri
          </motion.p>

          <motion.h1
            variants={item}
            className="font-black text-white tracking-tightest leading-[0.95]"
            style={{ fontSize: 'clamp(3rem, 8vw, 7rem)' }}
          >
            PROFESYONEL
            <br />
            <span className="text-accent-red">OTO BOYAMA</span>
          </motion.h1>

          <motion.p variants={item} className="text-text-muted text-lg md:text-xl font-light max-w-xl">
            25 yıllık ustalıkla aracınıza değer katıyoruz. Tekkeköy'ün güvendiği isim, şimdi sizin için.
          </motion.p>

          <motion.div variants={item} className="flex flex-wrap items-center gap-4 pt-4">
            <button
              onClick={onCta}
              className="px-8 py-4 rounded-full bg-accent-red text-white font-bold tracking-wide hover:scale-105 hover:shadow-2xl hover:shadow-accent-red/30 transition-all duration-500"
            >
              RANDEVU AL
            </button>
            <button
              onClick={onSecondaryCta}
              className="px-8 py-4 rounded-full border border-white/20 text-white font-bold tracking-wide hover:border-white hover:bg-white/5 transition-all duration-500"
            >
              HİZMETLER
            </button>
          </motion.div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.4 }}
          className="absolute left-1/2 -translate-x-1/2 bottom-0 hidden sm:flex flex-col items-center gap-2"
        >
          <span className="text-text-muted text-xs tracking-[0.3em] uppercase">Kaydır</span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
          >
            <ChevronDown className="text-accent-gold" size={22} />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
